import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Translators } from 'src/app/services/shared/translators.service';

@Component({
  selector: 'app-vendor-about',
  templateUrl: './vendor-about.component.html',
  styleUrls: ['./vendor-about.component.scss']
})
export class VendorAboutComponent implements OnInit {

  private readonly URL_PLAYSTORE = 'https://play.google.com/store/apps/details?id=io.cipbyte.signomedico&pcampaignid=web_share';

  idioma: Subscription;
  bgImage = [
    {
        img: 'assets/img/signo-medico/banner-bg-sm-1.png'
    }
  ];

  constructor(
      private translatorService: Translators,
  ) {}

  ngOnInit(): void {
  }

  irGooglePlay(): void {
    window.open(this.URL_PLAYSTORE, '_blank');
  }
}